import { AWSS3_UP_IMAGES_ENDPOINT, ERROR_API_ENDPOINT } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { UtilService } from '../share/util/util.service';
import { AuthenticateService } from '../share/authenticate/authenticate.service';
import { finalize } from 'rxjs/operators';
import { Auth } from 'aws-amplify';
import { from, Observable } from 'rxjs';

/** token.interceptorはHTTP通信直前をハンドリングする。
 * APIでトークン認証するためにヘッダにトークンを付与する。
 */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private utilServ: UtilService,
    private authServ: AuthenticateService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.utilServ.uTrans.addAsyncRequesting();

    return from(this.handle(request, next));
  }

  private async handle(request: HttpRequest<any>, next: HttpHandler) {
    /** 必要ならばリクエスト前にトークンをリフレッシュする
     *  トークン有効期限切れまで画面放置された後にAPI通信されると認証エラーになる為、この処理が必要。 */
    let idToken = '';
    if (this.authServ.token !== '') {
      const latestToken = await Auth.currentAuthenticatedUser();
      idToken = latestToken.signInUserSession.idToken.jwtToken;
    }

    // リクエストを加工
    const newRequest: HttpRequest<any> = this.getNewRequest(request, idToken);

    return next.handle(newRequest)
    .pipe(
      finalize(() => {
        // 通信終了後、通信中フラグプロパティを減算する
        this.utilServ.uTrans.removeAsyncRequesting();
      })
    ).toPromise();
  }

  /** リクエストを加工 */
  private getNewRequest(request: HttpRequest<any>, idToken: string): HttpRequest<any> {
    let newRequest;
    let newBody: any = request.body;

    newBody = this.setIpAndPg(newBody, request);

    if (this.isSetAuthHeader(request, idToken)) {
      newRequest = request.clone({
        body: newBody,
        setHeaders: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        },
      });
    } else {
      newRequest = request.clone({
        body: newBody,
      });
    }
    return newRequest;
  }

  /** リクエストbodyにip, pgを付与する */
  private setIpAndPg(newBody: any, request: HttpRequest<any>): any {
    let isStoreIp = false;
    let isStorePg = false;
    if (newBody !== null && 'ip' in newBody) {
      isStoreIp = true;
      isStorePg = true;
    }
    // 遷移ログ出力時にはip, pgには代入しない
    if (request.url.indexOf('api/Logs/smile9') >= 0) {
      isStoreIp = false;
      isStorePg = false;
    }

    if (isStoreIp) {
      newBody.ip = this.authServ.ip;
    }

    if (isStorePg) {
      let pg = '';
      if (location.pathname) {
        const pathArray: string[] = location.pathname.split('/');
        pg = pathArray[pathArray.length - 1];
      }
      newBody.pg = `${request.method}: ${pg}`;
    }

    return newBody;
  }

  /** Authorizationヘッダを付与するか判定 */
  private isSetAuthHeader(request: HttpRequest<any>, idToken: string): boolean {
    let isSetTokenInAuthHeader = true;

    if (idToken === '') {
      isSetTokenInAuthHeader = false;
    }

    // GoogleカレンダーAPIへのリクエスト時は不要なヘッダを抜かないとエラーとなる
    if (request.url.indexOf('https://www.googleapis.com/calendar/v3/calendars/') >= 0) {
      isSetTokenInAuthHeader = false;
    }
    // S3アップロード時も個別のserviceでヘッダを設定するので不要
    if (request.url.indexOf(AWSS3_UP_IMAGES_ENDPOINT) >= 0) {
      isSetTokenInAuthHeader = false;
    }
    if (request.url.indexOf('https://smile9-dldata.s3.ap-northeast-1.amazonaws.com') >= 0) {
      isSetTokenInAuthHeader = false;
    }
    // ErrorAPIへのリクエスト時にはAuthorizationヘッダを設定するので不要
    if (request.url.indexOf(ERROR_API_ENDPOINT) >= 0) {
      isSetTokenInAuthHeader = false;
    }
    return isSetTokenInAuthHeader;
  }
}
